import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AtsNotificationService } from './notifications.service';

@NgModule({
	imports: [CommonModule],
})
export class AtsNotificationModule {
	public static forRoot(duration: number = 6000): ModuleWithProviders<AtsNotificationModule> {
		return {
			ngModule: AtsNotificationModule,
			providers: [AtsNotificationService, { provide: 'duration', useValue: duration }],
		};
	}
}
